module.exports = {
	"base": {
		"welcome": "Velkommen til Mulligans, %{name}!",
		"user": "Brugeroplysninger",
		"devices": "Enheder",
		"refunds": "Refunderinger",
		"resources": "Resourcer",
		"transactions": "Transaktioner og refunderinger",
		"email": "E-mail",
		"password": "Adgangskode",
		"save": "Gem",
		"sign-out": "Log af",
		"cancel": "Annuller",
		"close": "Luk",
		"learn-more": "Lær mere",
		"required": "Påkrævet",
		"support": "Support",
		"bookshelf": "Boghylde",
		"launch": "Start",
		"download": "Download",
		"details": "Detaljer",
		"cannot-be-blank": "%{field} må ikke være tomt.",
		"saving": "Gemmer...",
		"done": "Udført",
		"failed": "Mislykkedes",
		"copy": "Kopiér"
	},
	"signin": {
		"login-failure": "E-mail eller adgangskode er forkert",
		"welcome-large": "Velkommen til <span class='inner'>%{brand} Kontocenter</span>",
		"welcome-small": "<span class='inner'>Account Center</span>",
		"signin-button": "Log på",
		"forgot-password": "Har du glemt din adgangskode",
		"new-to-vst": "Ny til %{brand}?",
		"create-account": "Opret en konto",
		"signing-in": "Logger på...",
		"signin-failed": "Log-in slog fejl"
	},
	"transactions": {
		"price": "Pris",
		"excluded": "(Ekskl. moms)",
		"quantity": "Antal",
		"confirmation#": "Bekræftelse #",
		"payment": "Betaling",
		"purchased": "Købt",
		"purchase-details": "Købsdetaljer",
		"subtotal": "Mellemregning",
		"total": "I alt",
		"tax": "Skat",
		"loading": "Hej med dig, vi henter dine transaktioner...",
		"no-purchases": "Du har ikke nogen køb.",
		"seller-vat": "Sælger MOMS",
		"total-vat": "%{vat} betalt i alt",
		"portion": "%{subTax} Skat %{rate}%",
		"vat-disclosure": "Pris inkluderer %{vat}",
		"purchases": "Køb",
		"refunded-items": "Refunderede varer",
		"book-title": "Bogtitel",
		"refund-details": "Refunderingsoplysninger",
		"print-receipt": "Udskriv kvittering",
		"request-refund": "Bed om refundering",
		"expired": "Udløbet",
		"expires-in": "Udløber %{date}",
		"details-refund": "Detaljer og refundering",
		"modal": {
			"cant-refund-title": "Refundering ikke tilgængelig",
			"cant-refund": "Din bog kan ikke refunderes af en af de følgende årsager.",
			"cant-refund-1": "Du har læst for stor en del af din bog.",
			"cant-refund-2": "Der er gået mere end 14 dage siden købsdatoen.",
			"cant-refund-3": "Din online ressource-kode er blevet vist.",
			"cant-refund-4": "Din bog er allerede blevet refunderet.",
			"cant-refund-5": "Alle koder er allerede blevet indløst og/eller refunderet.",
			"cant-refund-6": "Der er gået mere end 30 dage fra købsdatoen.",
			"cant-refund-support": "Hvis du ikke er sikker på %{brand} refunderingspolitik kan du kontakte <a href='%{support_url}' target='_blank'>support</a>."
		},
		"license": {
			"perpetual": "Online adgang udløber ikke",
			"days": "%{days} daglig adgang"
		}
	},
	"devices": {
		"description": "%{brand} lader dig have <span>%{desktop}</span> computere og <span>%{mobile}</span> mobile/tablet enheder aktiveret på samme tid.",
		"loading": "Hej, vi henter dine enheder :)",
		"no-active": "Du har ikke nogen aktive enheder.",
		"deactivate": "Deaktiver"
	},
	"user": {
		"personal-information": "Personlige oplysninger",
		"security-information": "Sikkerhedsoplysninger",
		"notifications": "Meddelelser",
		"first-name": "Fornavn",
		"last-name": "Efternavn",
		"change-password-title": "Ændre adgangskode",
		"current-password": "Nuværende adgangskode",
		"new-password": "Ny adgangskode",
		"security-password": "Adgangskode",
		"confirm-new-password": "Bekræft ny adgangskode",
		"security-question": "Sikkerhedsspørgsmål",
		"security-info-change": "Skift",
		"question": "Spørgmål",
		"answer": "Svar",
		"notifications-text": "Send mig lejlighedsvise opdateringer med email om aktivitet på min konto, produktopdateringer og specielle tilbud.",
		"loading": "Spot henter dine brugeroplysninger, lige et øjeblik 🐶",
		"change-password-text": "Adgangskoden skal indeholde mindst 8 tegn, et stort bogstav, et lille bogstav og et specielt tegn.",
		"email-locked": "Email låst",
		"email-locked-description": "Du har ikke adgang til at ændre din email.",
		"email-locked-more": "Kontakt venligst din administrator.",
		"security-question6": "Hvad er din favoritsport?",
		"security-question7": "Hvad er din favoritsmag på is?",
		"security-question8": "Hvad hedder dit favorit-kæledyr?",
		"security-question9": "Da du var lille, hvad ville du være, når du blev voksen?",
		"security-question10": "Hvad hed din favorit-lærer til efternavn?",
		"new-password-failure": "Adgangskoden opfylder ikke kravene",
		"confirm-password-failure": "Adgangskoderne skal være ens",
		"new-password-tooltip": "Skal indeholde mindst 8 tegn, et stort bogstav, et lille bogstav og et specielt tegn.",
		"enter-valid-email": "Indtast venligst en gyldig e-mail.",
		"password-cannot-be-same": "Adgangskoden må ikke være den samme, som den du brugte tidligere",
		"incorrect-password": "Forkert adgangskode",
		"complete-account": "Det ser ud til at du skal <a href='%{href}'>udfylde din konto.</a>",
		"completing-allows": "Når du udfylder din konto, kan du læse bøger offline på dine mobile apps og dele notater og anmærkninger med venner.",
		"error-updating-info": "There was an error updating your information.",
		"password-updated": "Password successfully updated",
		"security-updated": "Security question successfully updated",
		"info-updated": "User information successfully updated"
	},
	"resources": {
		"ancillaries": "Tilbehør",
		"access-codes": "Adgangskoder",
		"print-on-demand": "Udskriv ",
		"check-pod": "Tjek forlagets printmuligheder for dine bøger.",
		"check-now": "Tjek nu",
		"loading": "Vent, vi opdaterer dine ressourcer!",
		"in": "ind",
		"access-code-intro": "En adgangskode er et kodeord, som du bruger til at få adgang til kursusindhold online. Når du viser en kode til et element, kan du ikke gå tilbage til den. For at få flere oplysninger om, hvordan du bruger adgangskoder, gå til <a href='%{support_url}' target='_blank'>support</a>.",
		"expires": "Udløber",
		"expiration-message": "Indeholder oplysninger om hvordan du bruger adgangskoder.",
		"copy-fail": "Kan ikke kopiere. Vælg koden og kopier den manuelt.",
		"launch-site": "Start hjemmesiden",
		"launch-book": "Start bog",
		"reveal-code": "Vis kode",
		"no-resources": "Du har ikke nogen ressourcer.",
		"no-access-codes": "Du har ikke nogen adgangskoder.",
		"no-ancillaries": "Ikke noget tilbehør til denne titel",
		"name": "Navn",
		"type": "Type",
		"size": "Størrelse",
		"download-all": "Download alle",
		"back": "Tilbage til ressourcer"
	},
	"refunds": {
		"states": {
			"refunded": "Refunderet",
			"unavailable": "Refundering ikke tilgængelig"
		},
		"reasons": {
			"dropped": "Jeg sprang fra kurset",
			"wrong": "Det var den forkerte bog til mit kursus",
			"print": "Jeg bestemte mig til at købe bogen i stedet",
			"missing": "Bogen indeholder ikke alt, hvad jeg skal bruge til mit kursus (dvs. en CD, web adgang, videoer)",
			"other": "Andet"
		},
		"bulk": {
			"policy": "Ved at klikke på &quot;Fuld refundering&quot; nedenfor, accepterer jeg %{brand}s <a href='%{policy_url}' target='_blank'>refunderingspolitik</a>.",
			"complete": "Fuld refundering",
			"view-details": "Se refunderingsdetaljer",
			"success": "Du har anmodet om refundering. Vent 48 timer, mens anmodningen behandles.",
			"failure": "Hov - der opstod en fejl! Uheldigvis gik din refundering ikke igennem.",
			"retry": "Prøv igen",
			"support": "Kontakt support",
			"available-codes": "Tilgængelige koder",
			"codes-selected": "Valgte koder ",
			"download": "Download koder",
			"partially-refunded": "Delvist refunderet",
			"pick-one": "Du skal vælge mindst en kode for at få en refundering"
		},
		"refund": "Refunder",
		"all": "Refunder alle?",
		"missing-reason": "Du skal vælge en grund for at fortsætte",
		"missing-elaboration": "Uddyb venligst",
		"policy": "Ved at klikke på \"Færdiggør refunderingsanmodning\" nedenfor, accepterer jeg, at hvis jeg køber denne %{brand} e lærebog igen, vil jeg ikke kunne bede om flere refunderinger for den samme lærebog. Se refunderingspolitik.",
		"refunded": "Refunderet",
		"sorry": "Vi beklager at du ikke var tilfreds med dit køb.",
		"error": "Der gik noget galt",
		"error-explain": "Vi kunne ikke behandle din refundering. Prøv igen.",
		"why": "Fortæl hvorfor?",
		"no-refunds": "Du har ikke nogen refunderede elementer.",
		"select-codes": "Vælg kode(r) der skal refunderes:",
		"number": "Hvor mange?",
		"back": "Tilbage til refunderinger"
	},
	"purchases": {
		"back": "Tilbage til køb"
	},
	"global-bar": {
		"account": "Kontoindstillinger"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/locales/da.json
 ** module id = 974
 ** module chunks = 0
 **/